/*
 * @Author: linhao hao.lin@biz-united.com.cn
 * @Date: 2026-06-11 17:15:54
 * @LastEditors: linhao hao.lin@biz-united.com.cn
 * @LastEditTime: 2026-10-30 15:12:36
 * @FilePath: \crm-product\src\views\performanceCalculation\views\result_statement\annual_terminal_performance_report\form\detail.js
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
 */
import BasePage from '@/found/components/table_page';
import ScanDetailForm from '../scanDetail/detail.vue';
import ViewTaskForm from '../viewTask/detail.vue';
import ViewExcuteRecordForm from '../viewExcuteRecord/detail.vue';

export default {
  name: 'detail',
  extends: BasePage,
  props: {
    paramsProps: Object,
  },
  data() {
    return {
      params: {},
    };
  },
  components: {
    ScanDetailForm,
    ViewTaskForm,
    ViewExcuteRecordForm,
  },
  methods: {
    modalClick({
      val,
      row,
    }) {
      if (val.code === 'scan_code_record') {
        this.formName = 'ScanDetailForm';
        this.formConfig = {
          ...this.paramsProps,
          signAgreeCode: row.agreeCode,
        };
        this.modalConfig.title = '扫码记录';
        this.openFull();
      } else if (val.code === 'view_task') {
        this.formName = 'ViewTaskForm';
        this.formConfig = {
          ...this.paramsProps,
          signAgreeCode: row.agreeCode,
        };
        this.modalConfig.title = '查看任务';
        this.openFull();
      } else if (val.code === 'view_excute_record') {
        this.formName = 'ViewExcuteRecordForm';
        this.formConfig = {
          ...this.paramsProps,
          signAgreeCode: row.agreeCode,
        };
        this.modalConfig.title = '查看执行记录';
        this.openFull();
      }
    },
  },
  created() {
    this.getConfigList('agreement-list');
  },
};
